module.exports = __webpack_public_path__ + "static/media/slider-bg2.2cde32e3.png";